<template>
    <div v-if="this.loaded">
        <button v-on:click="toggleActive" class="image__play-video">
            <span class="visually-hidden">Speel video af</span>
            <Icon name="play" />
        </button>
        <portal to="modal" v-if="active">
            <div class="popup" v-on:click="toggleActive">
                <div class="popup__close-button">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                    <g fill-rule="evenodd" stroke-linecap="round"><line x1="12" x2="4" y1="12" y2="4" stroke="#ffffff" stroke-width="2">
                        </line><line x1="12" x2="4" y1="12" y2="4" stroke="#ffffff" stroke-width="2" transform="matrix(-1 0 0 1 16 0)"></line>
                    </g>
                </svg>
            </div>
            <div class="container">
                <div v-if="this.type == 'youtube'" class="video-container">
                    <iframe class="responsive-iframe" :src="getUrl()" title="Popup video" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; autoplay" allowfullscreen></iframe>
                </div>
                <div v-else-if="this.type == 'vimeo'" v-html="getVimeoIframe()" class="video-container"></div>
            </div>
            </div>
        </portal>
    </div>
</template>

<script>
import Icon from './Icon.vue';
import axios from 'axios';

export default {
    name: 'VideoOverlay',
    data() {
        return {
            loaded: false,
            active: false,
            vimeoVideo: null
        };
    },
    methods: {
        toggleActive: function() {
            this.active = !this.active;

            if(!this.vimeoVideo && this.type === 'vimeo') {
                this.fetchVimeoVideo();
            }
        },
        getUrl() {
            if(this.type === 'youtube') {
                return `${this.url}?enablejsapi=1`;
            }
        },
        getVimeoIframe() {
            if (this.vimeoVideo) {
                return this.vimeoVideo.html;
            }
        },
        fetchVimeoVideo(url) {
            // get vimeo iframe object from the oembed api,
            // https://developer.vimeo.com/api/oembed/videos#embedding-a-video-with-oembed-step-13
            
            axios
                .get(`https://vimeo.com/api/oembed.json?url=${this.url}`)
                .then(response => (this.vimeoVideo = response.data))
        }
    },
    props: ['url', 'type'],
    mounted: function(){
        this.loaded = true;
    },
    components: {
        Icon: Icon
    }
};
</script>

<style lang="scss">
.popup {
    position: fixed;
    inset: 0;
    height: 100vh;
    width: 100vw;
    background-color: rgba(12, 12, 12, 0.92);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    .video-container {
        display: flex;
        justify-content: center;
        position: relative;
        overflow: hidden;
        width: 100%;
        padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
        -webkit-border-radius: 16px;
        -moz-border-radius: 16px;
        border-radius: 16px;
        iframe {
            position: absolute;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            width: 100%;
            height: 100%;
        }
    }

    &__close-button {
        padding: 0px;
        position: absolute;
        top: 30px;
        right: 30px;
        svg {
            width: 30px;
            height: 30px
        }
        &:hover,
        &:focus {
            cursor: pointer;
        }
    }
}
</style>